<main class="main-content-app asidebarNav-colapse bottom-0 top-0" [class]="{'no-login':!hasUser, 'showMobileNav': showMobileNav}">
  <div class="main-content position-fixed z-2" style="background-color: var(--bs-tertiary-bg);">
    <app-header (openMobileNav)="handleOpenMobileNav()"></app-header>
    <div class="main-section overflow-auto position-absolute z-3 overflow-x-hidden" style="background-color: var(--bs-tertiary-bg);">
      <div class="container-fluid pt-2 pt-md-5 px-2 px-md-4 ">
<!--        Este router-outlet es el contenido de la pagina-->
        <router-outlet></router-outlet>
        <ng-content></ng-content>
      </div>
    </div>
  </div>
  @if(hasUser){
  <aside class="main-nav position-fixed z-3" style="background-color: var(--bs-tertiary-bg);">
    <app-sidenav></app-sidenav>
  </aside>
  }

  @if(hasUser){
<!--    codigo logged in-->
  }

  @if(!hasUser){
<!--    codigo logged out-->
  }
</main>
